import script from "./VisitCard.vue?vue&type=script&setup=true&lang=js"
export * from "./VisitCard.vue?vue&type=script&setup=true&lang=js"

import "./VisitCard.vue?vue&type=style&index=0&id=e531ebbc&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e531ebbc"]])

export default __exports__